import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { trackOrderById } from "../services/trackOrderService";

export const fetchTrackOrder = createAsyncThunk(
  "trackOrder/fetch",
  async (trackingId, { rejectWithValue }) => {
    try {
      const data = await trackOrderById(trackingId);
      if (!data) {
        return null;
      }
      return data;

    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch tracking info"
      );
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const trackOrderSlice = createSlice({
  name: "trackOrder",
  initialState,
  reducers: {
    resetTrackOrder: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrackOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrackOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTrackOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetTrackOrder } = trackOrderSlice.actions;
export default trackOrderSlice.reducer;
